export const ultimasNoticias = [
    
   //   {
   //      "imagen" : "assets/imgs/comisionpermanente.jpeg",

   //      "url" : "https://www.facebook.com/photo.php?fbid=1141667654661088&set=pb.100064535929070.-2207520000&type=3&locale=es_LA",
   //      "titulo" : "Contralores México",
       
   //     "fecha" : "Contralores México",
   //   }, 
   //   {
   //      "imagen" : "assets/imgs/CONTRALORIASOCIAL12.jpg",

   //      "url" : "https://www.facebook.com/share/p/1F7xuoj15B/",
   //      "titulo" : "Premio Nacional de Contralores ",
       
   //     "fecha" : "Contraloría Social",
   //   }, 


   //   {
   //      "imagen" : "assets/imgs/convocsatorias (2).jpg",
   //      "url" : "https://s-contraloria.hidalgo.gob.mx/interes/Convocatoria-Transparencia-en-Corto-2025.pdf",

   //      "titulo" : "Premio Nacional de Contralores ",
   //       "fecha" : "Contraloría Social",
   //  }, 

 
    {
        "imagen" : "assets/imgs/transparencia2026.jpg",
      //   "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf",
      "titulo" : "Premio Nacional de Contralores ",
        "fecha" : "Contraloría Social",
    },

     {
        "imagen" : "assets/imgs/conoci310526.jpg",
        "url" : "https://www.facebook.com/share/p/1BEdcVxfyD",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "El intercambio de conocimientos fortalece el desarrollo profesional y la construcción de instituciones más sólidas.",
    },
     {
        "imagen" : "assets/imgs/transformacion310526.jpg",
        "url" : "https://www.facebook.com/share/p/1CWfmfxHhr",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Mejorar los caminos es transformar la vida cotidiana de las familias hidalguenses.",
    }, 

    
    {
        "imagen" : "assets/imgs/juridicoia.jpg",
        "url" : "https://www.facebook.com/share/r/1Hp6hUCTCd",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Marco Jurídico IA.",
    },     


  
    {
        "imagen" : "assets/imgs/transformacon310526.jpg",
         "url" : "https://www.facebook.com/SecretariaContraloriaHgo/posts/pfbid0ASvF18Wu3ai3Qk5e5MPwfKGCB5Y1K5UtB18GLQxoqz1hSydfgtHUQQSx6xQbk8Rpl?rdid=dtmOwOF2668cf0l4#",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Como parte de las #RutasDeLaTransformación, el contralor Alvaro Bardales  acompañó al gobernador Julio Menchaca en su gira de trabajo por #Tetepango.",
    },

   
//  {
//         "imagen" : "noticias/Huejutla2.jpg",
//          "url" : "https://buzondigitalcontraloria.hidalgo.gob.mx/",
//         "titulo" : "Secretaría de Contraloría Hidalgo",
//        "fecha" : "Denuncia cualquier acto de corrupción o atención inadecuada por parte de las personas servidoras públicas",
//     },

 
 
 
    // {
    //     "imagen" : "noticias/comision.gif",
    //      "url" : "https://comisioncontralores.gob.mx/2023/",
    //     "titulo" : "Comisión Permanente de Contralores ",
    //    "fecha" : "Estados-Federación",
    // },     

    // {
    //     "imagen" : "noticias/9_jornada.jpg",
    //      "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1141123597339219/?mibextid=rS40aB7S9Ucbxw6v",
    //     "titulo" : "9 JORNADA DE CAPACITACIÓN ",
    //    "fecha" : "PARA LA TRANSFORMACIÓN DE HIDALGO",
    // },
    // {
    //     "imagen" : "noticias/convenio.jpg",
    //     "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1156571106119065",
    //     "titulo" : "Firma de Convenio de Donación de Sistemas por la Secretaría de la Honestidad ",
    //     "fecha" : "y la Secretaría de Contraloría de Hidalgo."
    // },
   


    // {
    //     "imagen" : "noticias/2da sesion.png",
    //     "url" : "https://www.facebook.com/share/p/14qTV3iovd/?mibextid=WC7FNe",
    //     "titulo" : " Segunda Asamblea Plenaria de la Comisión Permanente de Contralores Estado-Municipios",
    //     "fecha" : "28 de noviembre del 2024"
    // },



]